<template>
    <modal
        name="carrito-terminado"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="carrito-terminado"
        :adaptive="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">{{ $t('carrito.tiempo_terminado') }}</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <h3 class="text-danger">{{ $t('carrito.tiempo_terminado_comprar') }}</h3>
                <h4 class="text-danger">{{ $t('carrito.tiempo_terminado_continuar') }}</h4>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="close()">{{$t('carrito.tiempo_modal_cerrar')}}</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>

export default {
    methods: {
        close() {
            this.$emit('close');
        }
    },
}

</script>